import { ICheckboxGroupValue } from "../../CheckboxGroup/CheckboxGroup";
import { TFunction } from "i18n";
import { FiltersFieldNames, IFilterValues, SetFilterValues } from "../types";
import { IFilterTagProps } from "../../../Atoms/FilterTag/FilterTag";
import { IDropdownCheckboxValueItemConfig } from "../../../Molecules/DropdownCheckbox/DropdownCheckboxValue";

export interface GetCheckboxFacetsProps {
  name: FiltersFieldNames;
  fieldValue: ICheckboxGroupValue;
  fieldOptions: IDropdownCheckboxValueItemConfig[];
  setFilterValues: SetFilterValues<IFilterValues>;
  t: TFunction;
  getText?: (name: string, tagName?: string) => string;
  getOnClick?: (
    name: string,
    fieldValue: ICheckboxGroupValue,
    value: string
  ) => () => void;
}

export function getCheckboxTags({
  name,
  fieldValue,
  fieldOptions,
  setFilterValues,
  t,
  getText,
  getOnClick,
}: GetCheckboxFacetsProps) {
  return Object.keys(fieldValue).reduce<IFilterTagProps[]>((acc, value) => {
    if (fieldValue[value]) {
      const tagName = fieldOptions.find(
        (option) => String(option.value) === value
      )?.label;
      const text =
        getText?.(name, tagName) ??
        t(`common:search.filters.tagLabel.${name}`, { tagName });
      const onClick =
        getOnClick?.(name, fieldValue, value) ??
        (() => {
          setFilterValues({
            [name]: { ...fieldValue, [value]: false },
          });
        });

      return [
        ...acc,
        {
          id: `${name}-${value}`,
          text,
          onClick,
        },
      ];
    }

    return acc;
  }, []);
}
